import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=e334b2f6&scoped=true"
import script from "./AddDiscount.vue?vue&type=script&lang=js"
export * from "./AddDiscount.vue?vue&type=script&lang=js"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=e334b2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e334b2f6",
  null
  
)

export default component.exports